interface AnalyticsDataProvider {
    checkIsAlreadyInitiated(params: { name: string }): boolean;
    getDefaultAmazonAnalyticPurchaseData(): Promise<any>;
}

class SystemsRegistry {
    private static instance: SystemsRegistry;
    private analyticsProvider: AnalyticsDataProvider | null = null;

    private constructor() {}

    static getInstance(): SystemsRegistry {
        if (!SystemsRegistry.instance) {
            SystemsRegistry.instance = new SystemsRegistry();
        }
        return SystemsRegistry.instance;
    }

    registerAnalyticsProvider(provider: AnalyticsDataProvider): void {
        this.analyticsProvider = provider;
    }

    getAnalyticsProvider(): AnalyticsDataProvider | null {
        return this.analyticsProvider;
    }

    async getAmazonAnalyticsData(): Promise<{ aws_id: string }> {
        if (!this.analyticsProvider) {
            console.warn('Analytics provider not registered');
            return { aws_id: '' };
        }

        try {
            const isInitAmazonAnalytic = this.analyticsProvider.checkIsAlreadyInitiated({ name: 'amazon' });
            const data = isInitAmazonAnalytic
                ? await this.analyticsProvider.getDefaultAmazonAnalyticPurchaseData()
                : null;
            return data && data.aws_id ? { aws_id: data.aws_id } : { aws_id: '' };
        } catch (error) {
            console.warn('Error getting Amazon analytics data:', error);
            return { aws_id: '' };
        }
    }
}

export default SystemsRegistry;
